<div class="p-10 w-full d-flex flex-column">
  <div class="downloads_header">
    <h4 class="fui-title-small">{{ download.title + (download.type == "firmware" ? " v" + download.version : "") }}</h4>
  </div>
  <div class="downloads_details">
    @if (download.type != "link") {
      @if (fileType) {
        <small>{{ "download.file_type" | translate }}: {{ fileType | uppercase }}</small>
      }
      <small class="filename">{{ "download.file_name" | translate }}: {{ download.fileName || download.filename }}</small>
      @if (download.releaseDate) {
        <small>{{ "general.released" | translate }}: {{ download.releaseDate | date }}</small>
      }
      @if (download.contentLength || download.filesize) {
        <small>{{ "download.file_size" | translate }}: ~{{ download.contentLength || download.filesize | bytesToSize }}</small>
      }
      @if (download.osCompatibilityLabel) {
        <small>Compatible with: {{ download.osCompatibilityLabel }}</small>
      }
    }
    @if (download.type == "link") {
      <small>This is an online, interactive manual for {{ download.tileTitle }}.</small>
    }
  </div>
  <div class="downloads_button">
    @if (download.type != "firmware") {
      <button (keyup.enter)="downloadTokenizedAsset()" (click)="downloadTokenizedAsset()" class="brand-btn-reverse sm" target="_blank">
        <span class="glyphicon glyphicon-circle-arrow-down"></span>
        {{ download.type != "link" ? ("download.download" | translate) : "View" }}
      </button>
    }
    @if (download.type == "firmware") {
      <button (keyup.enter)="showFirmwareInstructions()" (click)="showFirmwareInstructions()" class="brand-btn-reverse sm" [disabled]="checkingFirmwareInstructions">
        @if (checkingFirmwareInstructions) {
          <fa-icon icon="spinner" animation="spin" class="m-r-5"></fa-icon>
        }
        {{ downloadsFirmwareDirectly ? "Download Firmware" : ("download.update_firmware" | translate) }}
      </button>
    }
  </div>
</div>
